import { BaseResponse } from '../../../../../types/api/api.types';
import { AUTH_ENDPOINTS } from '../../../../../utils/api/endpoints/authEndpoints';
import { InitPasswordQueryParams } from './InitPasswordForm.types';

const PREFIX = '[initPasswordQuery]';

export const INIT_PASSWORD_QUERY_KEY = 'INIT_PASSWORD';

export const initPasswordQuery = async ({
  commercialId,
  hash,
  password,
}: InitPasswordQueryParams) => {
  console.log(PREFIX, `Requesting user account creation...`);
  const response = await AUTH_ENDPOINTS.initPassword({ commercialId, hash, password });

  const { ok, data: json } = response;

  if (!ok) {
    const error = response.data;
    console.log(PREFIX, 'An error occurred.', error);
    throw error;
  }

  console.log(PREFIX, `Received user account creation.`);
  return json as BaseResponse;
};
